import { UtilsEnum } from '@/utils/UtilsEnum';

export const CENTRAL_REPROCESSAMENTO_STATUS_ENUM = UtilsEnum.create({
  CRIADO: { value: 'CRIADO', description: 'Criado' },
  AGUARDANDO_SOLICITACAO: { value: 'AGUARDANDO_SOLICITACAO', description: 'Solicitando' },
  AGUARDANDO_APROVACAO: { value: 'AGUARDANDO_APROVACAO', description: 'Aguardando aprovação' },
  AGUARDANDO_EXECUCAO: { value: 'AGUARDANDO_EXECUCAO', description: 'Aguardando execução' },
  EM_ANDAMENTO: { value: 'EM_ANDAMENTO', description: 'Em andamento' },
  FINALIZADO: { value: 'FINALIZADO', description: 'Finalizado' },
  ERRO: { value: 'ERRO', description: 'Falhou' },
});
